import qs from 'qs'
import request, { ResultHandler } from '@/core/utils/request'
const OrderBaseUrl = '/business/order'
export async function queryOrders(params) {
  const result = await request({
    url: OrderBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Query orders failed!') ?? null
}

export async function createOrder(data) {
  const result = await request({
    url: OrderBaseUrl,
    method: 'POST',
    data
  })
  return ResultHandler(result, 'Create order failed!')?.no ?? null
}

export async function createOrders(data) {
  const result = await request({
    url: OrderBaseUrl + '/bulk',
    method: 'POST',
    data,
    timeout: 2000000
  })
  return ResultHandler(result, 'Create orders failed!')?.nos ?? null
}

export async function detailOrder(orderId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId,
    method: 'GET'
  })
  return ResultHandler(result, 'Get order detail failed!') ?? null
}

export async function modifyOrder(orderId, order) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId,
    method: 'PUT',
    data: order
  })
  return ResultHandler(result, 'Modify order failed!') ?? null
}

export async function deleteOrder(orderId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId,
    method: 'DELETE',
    data: {
      id: orderId
    }
  })
  return ResultHandler(result, 'Delete order failed!') ?? null
}

export async function completeOrder(orderId) {
  const result = await request({
    url: OrderBaseUrl + '/complete/' + orderId,
    method: 'POST'
  })
  return ResultHandler(result, 'Complete order failed!') ?? null
}

export async function newLocalPallets(orderId, group) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/group',
    method: 'POST',
    data: group
  })
  return (
    ResultHandler(result, 'Failed to add new local pallets group!!') ?? null
  )
}

export async function modifyLocalPallets(orderId, groupId, group) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/group/' + groupId,
    method: 'PUT',
    data: group
  })
  return ResultHandler(result, 'Failed to modify local pallets group!!') ?? null
}

export async function modifyScanOrderGroup(orderId, groupId, group) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/scanGroup/' + groupId,
    method: 'PUT',
    data: group
  })
  return ResultHandler(result, 'Failed to modify local pallets group!!') ?? null
}

export async function removeLocalPallets(orderId, groupId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/group/' + groupId,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Failed to delete local pallets group!!') ?? null
}

export async function labelLocalPalletsGroup(orderId, groupId, start, end) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/group/' + groupId + '/label',
    method: 'GET',
    params: {
      start,
      end
    },
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType: 'blob'
  })
  return result
}

export async function labelLocalPallets(orderId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/label',
    method: 'GET',
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    responseType: 'blob'
  })
  return result
}

export async function localOrderReceipt(orderId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/receipt',
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function scanOrderGroupProductLabels(orderId, groupId) {
  const result = await request({
    url: OrderBaseUrl + '/' + orderId + '/scanGroup/' + groupId + '/labels',
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function searchtScanOrderProducts(params) {
  const result = await request({
    url: OrderBaseUrl + '/products',
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Failed to get scan order products!')?.items ?? null
}
